
function CustomMarker(id, latlng, map, args) {
    this.marker_id = id;
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
    this.customMap = map;
}

CustomMarker.prototype = new google.maps.OverlayView();

CustomMarker.prototype.draw = function() {

    let self = this;
    let div = this.div;

    if (!div) {

        div = this.div = document.createElement('div');

        div = self.createMapMarker(div);
    }

    let point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    if (point) {
        div.style.left = (point.x -12) + 'px';
        div.style.top = (point.y - 40) + 'px';
    }
};

CustomMarker.prototype.remove = function() {
    if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
    }
};

CustomMarker.prototype.getPosition = function() {
    return this.latlng;
};

CustomMarker.prototype.setVisible = function(visible) {
    if (visible)
        this.setMap(this.customMap);
    else
        this.setMap(null);
};

CustomMarker.prototype.addClass = function(className) {
    $(this.div).addClass(className);
};

CustomMarker.prototype.removeClass = function(className) {
    $(this.div).removeClass(className);
};


CustomMarker.prototype.createMapMarker = function(div){
    let self = this;

    div.className       = 'marker-pin';
    div.style.position  = 'absolute';
    div.style.cursor    = 'pointer';

    div.innerHTML       = ''
        + '<svg class="svg-pulse" x="0" y="0" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve"> <path d="M438.315,207.026c0-103.804-84.15-187.951-187.951-187.951S62.413,103.221,62.413,207.026c0,49.398,19.086,94.321,50.249,127.864h-0.049l137.751,145.879L388.069,334.89h-0.003C419.229,301.347,438.315,256.424,438.315,207.026z"/></svg>'
        + '<svg x="0" y="0" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve"> <path d="M438.315,207.026c0-103.804-84.15-187.951-187.951-187.951S62.413,103.221,62.413,207.026c0,49.398,19.086,94.321,50.249,127.864h-0.049l137.751,145.879L388.069,334.89h-0.003C419.229,301.347,438.315,256.424,438.315,207.026z"/></svg>';


    google.maps.event.addDomListener(div, "click", function(event) {
        google.maps.event.trigger(self.args.marker, "click");
    });

    google.maps.event.addDomListener(div, "mouseover", function(event) {
        google.maps.event.trigger(self.args.marker, "mouseover");
    });

    google.maps.event.addDomListener(div, "mouseout", function(event) {
        google.maps.event.trigger(self.args.marker, "mouseout");
    });

    let panes = this.getPanes();
    panes.overlayImage.appendChild(div);

    return div;
};

export default CustomMarker;
